<form [formGroup]="form">
    <nz-form-item>
        <nz-form-label>
            {{resolveKey("RoleCode") | translate}}
        </nz-form-label>
        <nz-form-control>
            <input formControlName="name" nz-input>
            <mm-form-error [name]="'name'" [labelName]="resolveKey('RoleCode') | translate"></mm-form-error>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label>
            {{resolveKey("RoleName") | translate}}
        </nz-form-label>
        <nz-form-control>
            <mm-i18n-text formControlName="displayName"></mm-i18n-text>
            <mm-form-error [name]="'displayName'" [labelName]="resolveKey('RoleName') | translate"></mm-form-error>

        </nz-form-control>
    </nz-form-item>

    <nz-form-item *ngIf="usePermission">
        <nz-form-label>
            {{resolveKey("Permissions") | translate}}
        </nz-form-label>
        <nz-form-control>
            <mm-permission-select formControlName="permissions"></mm-permission-select>
            <mm-form-error [name]="'displayName'" [labelName]="resolveKey('Permissions') | translate"></mm-form-error>
        </nz-form-control>
    </nz-form-item>

</form>

<div *nzModalFooter>
    <button nz-button (click)="save()" [nzType]="'primary'">
        {{"Common.OK" | translate}}
    </button>
    <button nz-button (click)="modalRef.close()">
        {{"Common.Cancel" | translate}}
    </button>
</div>